<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Paket Pengadaan" back_url="paket_pengadaan"/>
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="nama_paket_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Nama Paket Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="nama_paket_pengadaan" type="text" :class="{'p-invalid' : errors.nama_paket_pengadaan}" v-model="form.nama_paket_pengadaan" />
                            <small v-if="errors.nama_paket_pengadaan" id="name-help" class="p-error">Nama Paket Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="pagu_anggaran" class="col-12 mb-2 md:col-2 md:mb-0">Pagu Anggaran</label>
                        <div class="col-12 md:col-10">
                            <InputText id="pagu_anggaran" type="text" :class="{'p-invalid' : errors.pagu_anggaran}" v-model="form.pagu_anggaran" />
                            <small v-if="errors.pagu_anggaran" id="name-help" class="p-error">Pagu Anggaran Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jenis_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Jenis Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.jenis_pengadaan" :options="daftar_jenis_pengadaan" optionLabel="nama_pekerjaan" placeholder="Pilih Jenis Pengadaan" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.nama_pekerjaan}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.jenis_pengadaan" id="name-help" class="p-error">Jenis Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ruang_lingkup_pengadaan" class="col-12 mb-2 md:col-2 md:mb-0">Ruang Lingkup Pengadaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="ruang_lingkup_pengadaan" type="text" :class="{'p-invalid' : errors.ruang_lingkup_pengadaan}" v-model="form.ruang_lingkup_pengadaan" />
                            <small v-if="errors.ruang_lingkup_pengadaan" id="name-help" class="p-error">Ruang Lingkup Pengadaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="spesifikasi_pekerjaan" class="col-12 mb-2 md:col-2 md:mb-0">Spesifikasi Pekerjaan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="spesifikasi_pekerjaan" type="text" :class="{'p-invalid' : errors.spesifikasi_pekerjaan}" v-model="form.spesifikasi_pekerjaan" />
                            <small v-if="errors.spesifikasi_pekerjaan" id="name-help" class="p-error">Spesifikasi Pekerjaan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="mak" class="col-12 mb-2 md:col-2 md:mb-0">Mata Akun Kegiatan</label>
                        <div class="col-12 md:col-10">
                            <InputText id="mak" type="text" :class="{'p-invalid' : errors.mak}" v-model="form.mak" />
                            <small v-if="errors.mak" id="name-help" class="p-error">Mata Akun Kegiatan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="metode_pemilihan" class="col-12 mb-2 md:col-2 md:mb-0">Metode Pemilihan</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.metode_pemilihan" :options="daftar_metode_pemilihan" optionLabel="nama_metode_pemilihan" placeholder="Pilih Metode Pemilihan" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.nama_metode_pemilihan}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.metode_pemilihan" id="name-help" class="p-error">Metode Pemilihan Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_mulai_pemilihan_penyedia" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Mulai Pemilihan Penyedia</label>
                        <div class="col-12 md:col-10">
                            <Calendar id="jadwal_mulai_pemilihan_penyedia" type="date" :class="{'p-invalid' : errors.jadwal_mulai_pemilihan_penyedia}" v-model="form.jadwal_mulai_pemilihan_penyedia" dateFormat="dd/mm/yy" />
                            <small v-if="errors.jadwal_mulai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Mulai Pemilihan Penyedia Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_selesai_pemilihan_penyedia" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Selesai Pemilihan Penyedia</label>
                        <div class="col-12 md:col-10">
                            <Calendar id="jadwal_selesai_pemilihan_penyedia" type="date" :class="{'p-invalid' : errors.jadwal_selesai_pemilihan_penyedia}" v-model="form.jadwal_selesai_pemilihan_penyedia" dateFormat="dd/mm/yy" />
                            <small v-if="errors.jadwal_selesai_pemilihan_penyedia" id="name-help" class="p-error">Jadwal Selesai Pemilihan Penyedia Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_mulai_pelaksanaan_kontrak" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Mulai Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <Calendar id="jadwal_mulai_pelaksanaan_kontrak" type="date" :class="{'p-invalid' : errors.jadwal_mulai_pelaksanaan_kontrak}" v-model="form.jadwal_mulai_pelaksanaan_kontrak" dateFormat="dd/mm/yy" />
                            <small v-if="errors.jadwal_mulai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Mulai Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="jadwal_selesai_pelaksanaan_kontrak" class="col-12 mb-2 md:col-2 md:mb-0">Jadwal Selesai Pelaksanaan Kontrak</label>
                        <div class="col-12 md:col-10">
                            <Calendar id="jadwal_selesai_pelaksanaan_kontrak" type="date" :class="{'p-invalid' : errors.jadwal_selesai_pelaksanaan_kontrak}" v-model="form.jadwal_selesai_pelaksanaan_kontrak" dateFormat="dd/mm/yy" />
                            <small v-if="errors.jadwal_selesai_pelaksanaan_kontrak" id="name-help" class="p-error">Jadwal Selesai Pelaksanaan Kontrak Wajib Diisi</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="ppk_id" class="col-12 mb-2 md:col-2 md:mb-0">Pejabat Pembuat Komitmen</label>
                        <div class="col-12 md:col-10">
                            <Dropdown class="w-full md:w-14rem" v-model="form.ppk_id" :options="daftar_ppk" optionLabel="fullname" placeholder="Pilih Pejabat Pembuat Komitmen" required="required" >
                                <template #option="slotProps">
                                    <div class="country-item">
                                        <div>{{slotProps.option.fullname}}</div>
                                    </div>
                                </template>
                            </Dropdown>
                            <small v-if="errors.ppk_id" id="name-help" class="p-error">PPK Wajib Diisi</small>
                        </div>
                    </div>
                </template>  
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2" @click="submitForm()"/>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import {FilterMatchMode} from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import PermissionTreeTable from "../../Components/PermissionTreeTable";
import MenuTreeTable from "../../Components/MenuTreeTable";
import JetLabel from "@/Jetstream/Label";
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column, 
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        PermissionTreeTable,
        MenuTreeTable,
        JetLabel,
        Dropdown,
        Calendar,
    },
    props : {
        errors : Array,
        daftar_jenis_pengadaan : Array,
        daftar_metode_pemilihan : Array,
        daftar_ppk : Array,
    },
    data : function(){
        return {
                form : {
                    name : '',
                    permissions : [],
                    menus : [],
                },
            }
    },
    methods : {
        submitForm(){
            // alert(this.form)
            Inertia.post('/paket_pengadaan/', this.form);
        }
    }
}
</script>
